class LurenGallery extends HTMLElement {
  connectedCallback() {
    this.controller = new AbortController();
    const { signal } = this.controller;
    this.motion = matchMedia('(prefers-reduced-motion: reduce)');
    this.stopped = this.motion.matches || this.dataset.autoplay !== 'true';
    this.visible = false;
    this.hovered = false;
    this.focused = false;
    this.button = this.querySelector('[data-gallery-toggle]');
    if (!this.button || Number(this.dataset.count) < 2) return;
    this.querySelector('.luren-gallery-controls').hidden = false;
    this.button.addEventListener('click', () => {
      this.stopped = !this.stopped;
      this.update();
    }, { signal });
    this.addEventListener('pointerenter', event => { if (event.pointerType === 'mouse') { this.hovered = true; this.update(); } }, { signal });
    this.addEventListener('pointerleave', () => { this.hovered = false; this.update(); }, { signal });
    this.addEventListener('focusin', () => { this.focused = true; this.update(); }, { signal });
    this.addEventListener('focusout', event => { this.focused = this.contains(event.relatedTarget); this.update(); }, { signal });
    this.addEventListener('pointerdown', event => {
      if (event.target.closest('[data-gallery-toggle]')) return;
      this.stopped = true;
      this.update();
    }, { signal });
    this.addEventListener('keydown', event => {
      if (event.target.closest('[data-gallery-toggle]')) return;
      if (['ArrowLeft', 'ArrowRight', 'Enter', ' '].includes(event.key)) { this.stopped = true; this.update(); }
    }, { signal });
    document.addEventListener('visibilitychange', () => this.update(), { signal });
    this.motion.addEventListener('change', () => { if (this.motion.matches) this.stopped = true; this.update(); }, { signal });
    this.observer = new IntersectionObserver(entries => { this.visible = entries[0].isIntersecting; this.update(); }, { threshold:.35 });
    this.observer.observe(this);
    this.update();
  }
  update() {
    clearInterval(this.timer);
    if (!this.button) return;
    this.button.textContent = this.stopped ? this.dataset.play : this.dataset.pause;
    this.button.setAttribute('aria-pressed', String(!this.stopped));
    if (this.stopped || !this.visible || this.hovered || this.focused || document.hidden) return;
    this.timer = setInterval(() => {
      if (document.querySelector('dialog[open]')) return;
      const slideshow = this.querySelector('slideshow-component');
      if (typeof slideshow?.next === 'function') slideshow.next();
    }, Number(this.dataset.interval) * 1000 || 5500);
  }
  disconnectedCallback() { clearInterval(this.timer); this.observer?.disconnect(); this.controller?.abort(); }
}
if (!customElements.get('luren-gallery')) customElements.define('luren-gallery', LurenGallery);
